import { post, get } from '../utils/request';
import config from '@/config/index';

//登陆
// export const mobileLogin = p => post(config.devProxy+'/mobile/cjpl/CjplClass/mobileLoginH5Ajax', p);
export const mobileLogin = (p) => post(config.devProxy + '/zdcommon/mobileLogon/logon?type=8082', p);
//验证登录状态
export const checkLogin = (p) => post(config.devProxy + '/mobile/cjpl/CjplClass/checkLoginAjax', p);

export const lisFunctionVOTreeMobile = (p) => post(config.devProxy + '/author/SAuFunction/lisFunctionVOTreeMobile', p);

//登陆错误超过5次锁定账户
export const getLockAjax = (p) => post(config.devProxy + '/rdbase/personManage/PersonManage/getLockAjax', p);
//账号管理
export const modifyUserInfoAjax = (p) => post(config.devProxy + '/mobile/cjpl/CjplClass/modifyUserInfoAjax', p);
//账号信息查询
export const getUserInfoAjax = (p) => post(config.devProxy + '/mobile/mobileLogon/checkLogin', p);

export const getOpenId = (p) => post(config.devProxy2 + '/zdcommon/mobileLogon/getOpenId', p); //获取openid
export const checkIfCanLogin = (p) => post(config.devProxy + '/mobile/app/checkIfCanLogin', p); //验证是否能登录（能登陆走logonByTicket自动登录，不能则跳转登录页）
export const logonByTicket = (p) => post(config.devProxy + '/zdcommon/mobileLogon/logonByTicket', p); //自动登陆

export const ssoLogon = (p) => post(config.devProxy + '/author/Logon/ssoLogon', p); //code返回200直接登录
export const appLogon = (p) => post(config.devProxy + '/author/Logon/appLogon', p); //code返回300
export const matchMobileVerify = (p) => post(config.devProxy + '/zdcommon/sendMobileMessage/matchMobileVerify', p); //双因子登录
export const beSendMobileMessage = (p) => post(config.devProxy + '/zdcommon/sendMobileMessage/beSendMobileMessage', p); //获取手机验证码

//账号信息查询
export const getUserInfoAjax2 = (p) => post(config.devProxy + '/author/SAuUser/getUserInfo2', p);
export const appLogout = (p) => post(config.devProxy + '/author/Logon/appLogout', p);
//消息提醒
// export const loadActionAjax = p => post(config.devProxy+'/base/addressBook/InformationChange/loadActionAjax', p);
//消息已读  getTimestamp
// export const readActionAjax   = (getTimestamp,p) => post(config.devProxy+'/base/addressBook/InformationChange/readActionAjax?_='+getTimestamp, p);

//首页-获取代办数量
export const getCaseCountNew = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTaskNew/getCaseCount', p);

//价格采集-获取任务列表
export const getTaskNameList = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTask/getTaskNameList', p);
//价格采集-获取期号范围
export const getIssueRangeList = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTask/getIssueRangeList', p);
//价格采集-采集任务
export const getCollectionTaskNew = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTaskNew/getCollectionTask', p);
//价格采集详情-监测点下拉框
export const getStationList = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTaskNew/getStationList', p);
//价格采集详情-填报详情（填报数量少）
export const dataGridNew = (p) => post(config.devProxy + '/jgjc/sjcj/CollectionData/dataGridNew', p);
//价格采集详情-填报详情(填报数量多)
export const dataGrid = (p) => post(config.devProxy + '/jgjc/sjcj/CollectionData/dataGrid', p);
//价格采集详情-查看日志
export const getDateRecord = (p) => post(config.devProxy + '/jgjc/sjcj/CollectionData/getDate', p);
//价格采集详情-保存
export const saveRow = (p) => post(config.devProxy + '/jgjc/sjcj/CollectionData/saveRow', p);
//价格采集详情-上报
export const upOK = (p) => post(config.devProxy + '/jgjc/sjcj/CollectionData/upOk', p);

//区县填报审核-待填报任务
export const getCountyReportList = (p) => post(config.devProxy + '/mobile/MobileCountyReportUrls/getCountyReportList', p);
//区县填报审核-监测点下拉框
export const getCountryStationList = (p) => post(config.devProxy + '/mobile/MobileCountyReportUrls/getCountryStationList', p);
//区县填报审核-审核
export const upOkCountry = (p) => post(config.devProxy + '/mobile/MobileCountyReportUrls/upOk', p);

//市级代填报-待填报任务
export const getCityCollectionTask = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTaskNew/getCityCollectionTask', p);

//价格审核-待审核任务
export const getTodayCheckNew = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTaskNew/getTodayCheck', p);
//价格审核-监测地点下拉框
export const getCheckStationList = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTaskNew/getCheckStationList', p);

//均价审核-地州市下拉框
export const getAreaList = (p) => post(config.devProxy + '/jgjc/sjcj/CollectionData/getAreaList', p);
//均价审核-均价页面
export const getBatchExamList = (p) => post(config.devProxy + '/ythyw/provinceExamUrls/getBatchExamList', p);
//均价审核-均价详细页面
export const getExamDetailsList = (p) => post(config.devProxy + '/ythyw/provinceExamUrls/getExamDetailsList', p);

//均价-省保存
export const provinceSavePriceRow = (p) => post(config.devProxy + '/ythyw/provincetaskUrls/provinceSavePriceRow', p);
//均价-获取监测点列表
export const listForPassAndReturn = (p) => post(config.devProxy + '/ythyw/provinceExamUrls/listForPassAndReturn', p);
// 均价-审核通过
export const checkPass = (p) => post(config.devProxy + '/ythyw/provinceExamUrls/checkPass', p);
// 均价-审核撤销
export const checkRevoke = (p) => post(config.devProxy + '/ythyw/provinceExamUrls/checkRevoke', p);
// 均价-审核退回
export const sendBack = (p) => post(config.devProxy + '/jgjc/sjcj/CollectionData/sendBack', p);
//省审核
export const provinceCheck = (p) => post(config.devProxy + '/jgjc/sjsh/ProvinceCheckData/upOK', p);
//撤销省审核
export const provinceRevoke = (p) => post(config.devProxy + '/jgjc/sjsh/ProvinceCheckData/revoke', p);
//省退回
export const provinceRedo = (p) => post(config.devProxy + '/jgjc/sjsh/ProvinceCheckData/redo', p);
//省保存
export const provinceSaveRow = (p) => post(config.devProxy + '/jgjc/sjsh/ProvinceCheckData/saveRow', p);
//市审核
export const cityCheck = (p) => post(config.devProxy + '/jgjc/sjsh/CityCheckData/upOk', p);
//市退回
export const cityRedo = (p) => post(config.devProxy + '/jgjc/sjsh/CityCheckData/redo', p);
//市保存
export const citySaveRow = (p) => post(config.devProxy + '/jgjc/sjsh/CityCheckData/saveRow ', p);
//市撤销
export const cityRevoke = (p) => post(config.devProxy + '/jgjc/sjsh/CityCheckData/revoke ', p);
//区县审核
export const countyCheck = (p) => post(config.devProxy + '/jgjc/sjsh/CountyCheckData/upOk', p);
//区县退回
export const countyRedo = (p) => post(config.devProxy + '/jgjc/sjsh/CountyCheckData/redo', p);
//区县撤销
export const countyRevoke = (p) => post(config.devProxy + '/mobile/MobileCountyReportUrls/countyRevoke', p);
//区县退回
export const countyBack = (p) => post(config.devProxy + '/mobile/MobileCountyReportUrls/countyBack', p);
//区县保存
export const countySaveRow = (p) => post(config.devProxy + '/jgjc/sjsh/CountyCheckData/saveRow ', p);

//预警查询-查询
export const getQueryWarnData = (p) => post(config.devProxy + '/mobile/cjpl/CjplClass/getQueryWarnData', p);

//通知公告-查询
export const tzloadActionAjax = (p) => post(config.devProxy + '/base/manageNotify/ManageNotify/loadActionAjax', p);
//通知公告-已读
export const tzReadActionAjax = (getTimestamp, p) => post(config.devProxy + '/base/manageNotify/ManageNotify/readActionAjax?_=' + getTimestamp, p);

// 通讯录-查询
export const addressListAjax = (p) => post(config.devProxy + '/base/addressBook/AddressBook/getAddressBookAjax', p);

//首页代办列表
export const getTaskGrid = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTask/getTaskGrid', p);
//通讯录
// export const addressListAjax = p => post(config.devProxy+'/mobile/cjpl/CjplClass/addressListAjax', p);
///base/addressBook/AddressBook/getAddressBookAjax
//价格采集 tableList 日报 周报 旬报 月报
export const getCjpl = (p) => post(config.devProxy + '/mobile/cjpl/CjplClass/getCjpl', p);
//价格采集 当日任务
export const getCollectionTask = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTask/getCollectionTask', p);
//价格采集 全部任务
// export const getAllCollectionTask = p => post(config.devProxy+'/mobile/cjpl/MobileCollectionTask/getAllCollectionTask', p);

//价格审核
export const getTodayCheck = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTask/getTodayCheck', p);
//消息提醒
// export const loadActionAjax = p => post(config.devProxy+'/base/addressBook/InformationChange/loadActionAjax', p);
//消息已读  getTimestamp
// export const readActionAjax   = (getTimestamp,p) => post(config.devProxy+'/base/addressBook/InformationChange/readActionAjax?_='+getTimestamp, p);
//通知公告 /base/manageNotify/ManageNotify/loadActionAjax

//事项审核 全部任务
// export const getAllCheck = p => post(config.devProxy+'/mobile/cjpl/MobileCollectionTask/getAllCheck', p);
//市审核
// export const countyCheck = p => post(config.devProxy+'/jgjc/sjsh/CountyCheckData/upOK', p);

//导出全省汇总表 根据日期获取数据 hbData thisData hbDate
// export const getDataAjax= p => post(config.devProxy+'/jgjc/collect/PriceController/getDataAjax', p);
//导出全省汇总表 根据数据导出
// export const exportModelRice= p => post(config.devProxy+'/jgjc/collect/CollectQuery/exportMobileRice', p);
//价格发布publishListAjax
// export const publishListAjax = p => post(config.devProxy+'/mobile/cjpl/CjplClass/publishListAjax', p);

//预警查询期号范围
// export const getIssueRangeList = p => post(config.devProxy+'/mobile/cjpl/CjplClass/getIssueRangeList', p);
//首页标的数量查询
export const getCaseCount = (p) => post(config.devProxy + '/mobile/cjpl/MobileCollectionTask/getCaseCount', p);

//获取待办理的列表信息
export const getHandleList = (p) => post(config.devProxy + '/jgjc/handleWarnData/WarnHandleController/getHandleList', p);
//获取已办理的列表信息
export const getHandleOverList = (p) => post(config.devProxy + '/jgjc/handleWarnData/WarnHandleController/getHandleOverList', p);
//发布预警
export const startWarn = (p) => post(config.devProxy + '/jgjc/handleWarnData/WarnHandleController/startWarn', p);
//取消预警
export const cancelWarn = (p) => post(config.devProxy + '/jgjc/handleWarnData/WarnHandleController/cancelWarn', p);
//撤销预警
export const revokeWarn = (p) => post(config.devProxy + '/jgjc/handleWarnData/WarnHandleController/revokeWarn', p);
//获取期号下拉列表
export const getWarnIssueRangeList = (p) => post(config.devProxy + '/jgjc/handleWarnData/WarnHandleController/getWarnIssueRangeList', p);

//市场巡查列表-获取市场巡查列表
export const getWarnInspection = (p) => post(config.devProxy + '/mobile/WarnInspectionUrls/getWarnInspection', p);
//市场巡查列表-删除市场巡查事项
export const deleteWarnInspectionById = (p) => post(config.devProxy + '/mobile/WarnInspectionUrls/deleteWarnInspectionById', p);
//市场巡查列表-新增、编辑市场巡查事项
export const saveOrUpdateWarnInspection = (p) => post(config.devProxy + '/mobile/WarnInspectionUrls/saveOrUpdateWarnInspection', p);
//市场巡查列表-公共-上传图片
export const uploadAppFileAjax = (p) => post(config.devProxy + '/zdcommon/fileUpload/upload', p);
//市场巡查列表-公共-删除图片
export const deleteFileAjax = (p) => post(config.devProxy + '/zdcommon/fileUpload/deleteFile', p);
//市场巡查列表-回显图片
export const getFileDescList = (p) => post(config.devProxy + '/zdcommon/fileUpload/getbackFile', p);

// 判断旧密码是否正确
export const judgePassword = (p) => post(config.devProxy + '/author/SAuUser/judgePassword', p);
// 修改登录密码
export const resetPassword = (p) => post(config.devProxy + '/author/SAuUser/resetPassword', p);

// 省级代填报
export const getCollectionTaskProList = (p) => post(config.devProxy + '/mobile/mobileCollectionTaskProUrls/getCollectionTaskProList', p);

// 国家数据上报
export const getJgjcReportExamTask = (p) => post(config.devProxy + '/jgjcReport/jgjcReportExamUrls/getJgjcReportExamTask', p);

export const getTaskList = (p) => post(config.devProxy + '/jgjcReport/jgjcReportExamUrls/getTaskList', p);

export const getJgjcReportExamStation = (p) => post(config.devProxy + '/jgjcReport/jgjcReportExamUrls/getJgjcReportExamStation', p);

export const reportUpOk = (p) => post(config.devProxy + '/jgjcReport/jgjcReportExamUrls/upOk', p);

export const listCodeItemBatch2 = (p) => post(config.devProxy + '/zdcommon/codeItemDefine/listCodeItemBatch2', p);

export const getFillList = (p) => post(config.devProxy + '/xcxwjcx/wjdc/getFillList', p);

export const getAlreadySendInfo = (p) => post(config.devProxy + '/ythyw/monitorReportUrls/getAlreadySendInfo', p);

export const preDownloadPdfFile = (p) => post(config.devProxy + '/ythyw/monitorReportUrls/preDownloadPdfFile', p);

export const getWarnPageList = (p) => post(config.devProxy + '/mobile/warnHandleXiaoMaiUrls/getWarnPageList', p);

export const knowWarn = (p) => post(config.devProxy + '/mobile/warnHandleXiaoMaiUrls/knowWarn', p);

export const getHugeType = (p) => post(config.devProxy + '/knowledge/importKnowledgeManage/getFileType', p);

export const queryTitleListAjax = (p) => post(config.devProxy + '/knowledge/knowledgeListQuery/queryFileInfoList', p);

export const getDailyTask = (p) => post(config.devProxy + '/mobile/DailyTaskQueryUrls/getDailyTask', p);

export const getTaskListSH = (p) => post(config.devProxy + '/mobile/MobileCollectionTaskSet/getTaskList', p);

export const modifyIfJcdApp = (p) => post(config.devProxy + '/mobile/MobileCollectionTaskSet/modifyIfJcdApp', p);

export const getSendUserList = (p) => post(config.devProxy + '/ythyw/monitorReportUrls/getSendUserList', p);
export const pushReport = (p) => post(config.devProxy + '/ythyw/monitorReportUrls/pushReport', p);

